(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileSlackChannelInfo', ["path", "$q", "widgetPolling", "fileDao", "modulesDao", "metaInfoConverter", function (path, $q, widgetPolling, fileDao, modulesDao, metaInfoConverter) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/slack_channel/slack-channel-info').template('slack-channel-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                $scope.widgetApi = {};
                $scope.model = {};
                $scope.loadData = function () {
                    return fileDao.entityInfo('slack_channel', id).then(function (response) {
                        var input = {};
                        input.originData = response.data || {};
                        $scope.model.info = {};
                        $scope.model.info.lines = [{
                                text: input.originData.name || 'No channel name',
                                class: 'file-name channel-name'
                            }];
                        var queries = [modulesDao.entityInfo('slack', 'slack_channel')];
                        var userInfo;
                        if (input.originData && input.originData.creator) {
                            queries.push(fileDao.entityInfo('slack_user', input.originData.creator));
                            userInfo = true;
                        }
                        $q.allSettled(queries).then(function (respes) {
                            input.entityInfo = respes[0].value && respes[0].value.data || {};
                            input.resolvers = { creator: {} };
                            if (userInfo) {
                                input.resolvers.creator = respes[1].value && respes[1].value.data || {};
                            }
                            // meta-info logic
                            var metaInfo = {
                                key: {},
                                value: {},
                                pair: { class: 'file-meta-data' },
                                args: {
                                    beautifyKey: true,
                                    whiteList: [
                                        'purpose',
                                        'topic',
                                        'type',
                                        'created_time',
                                        {
                                            key: 'creator',
                                            type: 'resolver',
                                            resolverEntity: 'slack_user',
                                            resolverKey: 'display_name'
                                        },
                                        {
                                            key: 'is_archived',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_general',
                                            hiddenPairAny: { value: false }
                                        }
                                    ]
                                }
                            };
                            metaInfo.data = metaInfoConverter(input, metaInfo.args);
                            $scope.model.metaInfo = metaInfo;
                        });
                    }, function (err) {
                        console.log('Error in slack channel info:', err);
                    });
                };
            }
        };
    }]);
}());